/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.Accountsync {
    'use strict';

    import IModalService = Meevo.Components.Modal.IModalService;

    enum AccountSyncLogTypeEnum {
        Sync,
        Delete
    }

    enum AccountSyncLogTransactionStatus {
        Error,
        Success
    }

    interface IAccountSyncLogRequest {
        criteria?: any;
        itemsPerPage: number;
        clientGlobalId?: string;
        asLocationId?: number;
        sortBy?: string;
        sortDirection?: Model.SortDirection
    }

    interface IParams {
        startDate: Date,
        endDate: Date,
        employeeId: number,
        actionTypes: Array<any>,
        applicationConnectionId: string,
        filter: string,
        maintenanceMode: boolean,
        isGlobal: boolean,
    }

    interface ILogsInformation {
        itemsAdded: number;
        invoices: number;
        creditMemos: number;
    }

    interface ILogsController {
        arrayResults: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        params: IParams;
        request: IAccountSyncLogRequest;        
        logsInfromationData: ILogsInformation;
        connectionList: IConnectionListItem[];
        choosedConection: IConnectionListItem;
        employee: any;
        filterSync: boolean;
        filterDelete: boolean;
        syncStatuses: Object;

        getLogList: (data?) => void;
        showFilter: () => void;
        applyFilter: (connection?) => void;
        clearAdvancedSearch: () => void;
        onSyncClicked: () => void;
        onDeleteClicked: () => void;
        stylizationTooltip?: () => void;
    }

    class LogsController implements ILogsController {

        public arrayResults: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;

        public params: IParams = {
            startDate: moment().startOf('day').toDate(),
            endDate: moment().add(1, 'day').startOf('day').subtract(1, 'm').toDate(),
            employeeId: null,
            actionTypes: [],
            applicationConnectionId: null,
            filter: null,
            maintenanceMode: true,
            isGlobal: true
        }
        public request: IAccountSyncLogRequest = {
            criteria: this.params,
            itemsPerPage: 25,
            sortBy: 'actionStartDateTime',
            sortDirection: Model.SortDirection.Descending
        };
        public logsInfromationData: ILogsInformation = {
            itemsAdded: 2,
            invoices: 15,
            creditMemos: 2
        };
        public connectionList: IConnectionListItem[];
        public choosedConection: IConnectionListItem;
        public employee: any;
        public filterSync: boolean;
        public filterDelete: boolean;

        public syncStatuses = {
            [SyncProcessingStatusEnum.NotProcessed]: 'LABEL_NOT_PROCESSED',
            [SyncProcessingStatusEnum.InProcess]: 'HEADER_SYNC_IN_PROCESS',
            [SyncProcessingStatusEnum.Complete]: 'LABEL_COMPLETED',
            [SyncProcessingStatusEnum.Failed]: 'LABEL_FAILED',
            [SyncProcessingStatusEnum.InError]: "LABEL_ERROR"
        }

        static $inject = [
            'meevo.components.modal.ModalService',
            'meevo.components.common.DataService',
            '$translate',
            '$scope'
        ];

        constructor(
            private modalService: IModalService,
            private dataService: Components.BaseClasses.IDataService,
            protected $translate: angular.translate.ITranslateService,
            protected $scope: angular.IScope
        ) { }

        $onInit(): void {
            this.$scope.$on('$mdMenuOpen', () => {
                this.stylizationTooltip();
            });

            this.getLogList();
        }

        getResults(url, onPageLoad) {
            return new Meevo.Components.BaseClasses.PagedResults(this.dataService, url, onPageLoad);
        }

        getLogList(): void {
            let request: IAccountSyncLogRequest = angular.copy(this.request),
                url: string = 'AccountSync/Log';

            this.arrayResults = this.getResults(url, null);
            this.arrayResults.initSearch(request);
        }

        applyFilter(connection?): void {
            let request: IAccountSyncLogRequest = angular.copy(this.request);

            if (connection && connection !== 'none') {
                request.criteria.applicationConnectionId = this.request.criteria.applicationConnectionId = connection.applicationConnectionId;
            }
            if (connection === 'none') {
                request.criteria.applicationConnectionId = this.request.criteria.applicationConnectionId = null;
            }
            if (this.employee) {
                request.criteria.employeeId = this.employee.id;
            }

            this.arrayResults.initSearch(request);
        }

        clearAdvancedSearch(): void {
            this.params.actionTypes = [];
            this.employee = null;
            this.applyFilter();
        }

        showFilter(): void {
            let context = this;           

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/accountsync/components/logs/logs.advFilters.template.html',
                controller: 'meevo.components.controls.ModalContextController',
                controllerAs: "ctrl",
                clickOutsideToClose: true,
                locals: {
                    context: context
                }
            }
            this.modalService.showCustom(options);
        }
    
        onSyncClicked(): void {
            if (this.filterSync) {
                this.params.actionTypes.push(AccountSyncLogTypeEnum.Sync);
            } else {
                let position = this.params.actionTypes.indexOf(AccountSyncLogTypeEnum.Sync);
                if (~position) {
                    this.params.actionTypes.splice(position, 1);
                }
            }
        }
        onDeleteClicked(): void {
            if (this.filterDelete) {
                this.params.actionTypes.push(AccountSyncLogTypeEnum.Delete);
            } else {
                let position = this.params.actionTypes.indexOf(AccountSyncLogTypeEnum.Delete);
                if (~position) this.params.actionTypes.splice(position, 1);
            }
        }

        /**
         * Check if needed show errors
         * @param {any} logItem
         * @returns {boolean}
         */
        private isErrorInLog(logItem: any): boolean {
            if (!logItem || !logItem.details.length) return false;
            return !!logItem.details.find(el => el.transactionStatus === AccountSyncLogTransactionStatus.Error);
        }

        /**
         * Returned the amount of current Api Type
         * @param {any} logItem
         * @param {string} apiType
         * @returns {number}
         */
        private getCountOfApiType(logItem, apiType: string): number {
            if (!logItem || !logItem.details.length) return 0;

            return logItem.details.filter(el => el.apiType === apiType).length;
        } 

        /**
         * Returned the array of Api Names
         * @param {any} logItem
         * @param {string} apiType
         * @returns {any}
         */
        private getApiNames(logItem): any {
            if (!logItem || !logItem.details.length) return [];

            return _.unique(logItem.details.map(el => el.apiType));
        }

        /**
         * Returned the array of Qb Error 
         * @param {any} logItem
         * @returns {string[]}
         */
        private getQbApiErrors(logItem): string[] {
            if (!logItem || !logItem.details.length) return [];

            return logItem.details.filter(el => el.transactionStatus === AccountSyncLogTransactionStatus.Error).map(el => {
                return this.$translate.instant('TEXT_QB_RETURNED_ERROR',
                    {
                        accountName: el.apiType,
                        errorException: el.notes
                    }); 
            });
        }

        get accountSyncLogTypeEnum(): any {
            return AccountSyncLogTypeEnum;
        }

        get syncStatusEnum(): any {
            return SyncProcessingStatusEnum;
        }

        // Binded methods
        stylizationTooltip(): void {}
    }

    class LogsComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/accountsync/components/logs/logs.template.html';
        controller = LogsController;
        controllerAs = 'model';
        bindings: any = {
            connectionList: '=',
            stylizationTooltip: '&'
        };
    }

    angular.module('meevo.plugins.accountsync')
        .component('accountasyncLogsComponent', new LogsComponent());

}

